import { createRootRoute, createRoute, createRouter, Outlet, useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import { Shell } from "./components/Shell.tsx";
import { openPalette } from "./lib/store.ts";
import { Agenda } from "./pages/Agenda.tsx";
import { Capture } from "./pages/Capture.tsx";
import { History } from "./pages/History.tsx";
import { Inbox } from "./pages/Inbox.tsx";
import { Feedback } from "./pages/Feedback.tsx";
import { Lot } from "./pages/Lot.tsx";
import { Settings } from "./pages/Settings.tsx";
import { Sources } from "./pages/Sources.tsx";

const root = createRootRoute({ component: Outlet });
const shell = createRoute({ getParentRoute: () => root, id: "shell", component: Shell });

/** Web Share Target: the phone's share sheet sends us a URL (sometimes inside "text"). */
function Share() {
  const { url, text } = useSearch({ strict: false }) as { url?: string; text?: string };
  const navigate = useNavigate();
  useEffect(() => {
    const found = url || /https?:\/\/\S+/.exec(text ?? "")?.[0] || "";
    void navigate({ to: "/", replace: true });
    openPalette(found);
  }, [url, text, navigate]);
  return null;
}

const routeTree = root.addChildren([
  shell.addChildren([
    createRoute({ getParentRoute: () => shell, path: "/", component: Agenda }),
    createRoute({ getParentRoute: () => shell, path: "/lot/$id", component: Lot }),
    createRoute({ getParentRoute: () => shell, path: "/inbox", component: Inbox }),
    createRoute({ getParentRoute: () => shell, path: "/history", component: History }),
    createRoute({ getParentRoute: () => shell, path: "/sources", component: Sources }),
    createRoute({ getParentRoute: () => shell, path: "/settings", component: Settings }),
    createRoute({ getParentRoute: () => shell, path: "/feedback", component: Feedback, validateSearch: (s: Record<string, unknown>) => ({ lot: typeof s.lot === "string" ? s.lot : undefined }) }),
    createRoute({ getParentRoute: () => shell, path: "/share", component: Share, validateSearch: (s: Record<string, unknown>) => ({ url: s.url as string | undefined, text: s.text as string | undefined }) }),
  ]),
  createRoute({ getParentRoute: () => root, path: "/capture", component: Capture }),
]);

export const router = createRouter({ routeTree, defaultPreload: false, scrollRestoration: true });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
